import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Divider } from "@/components/ui/divider";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import i18n from "i18n-js";
import { cleanImages } from "../components/media/MediaSelector";
import { switchScreen } from '../hooks/navigate';
import BasicButton from "../components/basic/BasicButton";
import { backendRequest } from "../stores/thunks";
import { logout } from "../stores/mainSlice";
import * as Notifications from 'expo-notifications';

export default function Logout({ route, navigation }) {
    const dispatch = useDispatch()
    const sync = useSelector((state) => state?.server?.sync)
    const user = useSelector((state) => state.user)
    const token = useSelector((state) => state.cloudMessaging.token)

    const overAndOut = async (clean) => {
        switchScreen(navigation, 'MainStack')
        if (clean) {
            // TODO: Clean only images of current user!
            await cleanImages()
            await Notifications.cancelAllScheduledNotificationsAsync()
            dispatch(backendRequest("DELETE_CLOUD_TOKEN", `/cloud-messaging/${token}`, null, "DELETE", true))
            dispatch(logout({ clean: true }))
        } else {
            dispatch(logout({ clean: false }))
        }
    }

    return (
        <VStack space='2xl' className="justify-center py-3 px-3">
            <VStack space='lg'>
                <Text className="text-secondary-900 text-xl">{i18n.t('login.logoutText')}</Text>
                {!user.demo && <Text className="text-secondary-900 text-xl font-medium">{i18n.t(sync?.length ? 'login.logoutNoSync' : 'login.logoutSync')}</Text>}
                <BasicButton bg='bg-error-600' onPress={() => { overAndOut(true) }} text={i18n.t('login.logout')}/>
            </VStack>
            <Divider />
            <VStack space='lg'>
                <Text className="text-secondary-900 text-xl">{i18n.t('login.switchText')}</Text>
                <BasicButton bg='bg-error-600' onPress={() => { overAndOut(false) }} text={i18n.t('login.switch')}/>
            </VStack>
        </VStack>
    );
}
